const NETWORK_ERROR_PATTERNS = [
  'failed to fetch',
  'network request failed',
  'networkerror',
  'load failed',
  'timeout',
  'timed out',
];

const PERMISSION_ERROR_PATTERNS = [
  'product not found',
  'access denied',
  'forbidden',
  'insufficient',
];

export function getShareLinkErrorMessage(error: unknown): string | null {
  if (!(error instanceof Error)) {
    return 'Could not create the share link. Please try again.';
  }

  const normalizedMessage = error.message.trim().toLowerCase();

  if (normalizedMessage === 'authentication required') {
    return null;
  }

  if (NETWORK_ERROR_PATTERNS.some((pattern) => normalizedMessage.includes(pattern))) {
    return 'Network error. Check your connection and try again.';
  }

  if (PERMISSION_ERROR_PATTERNS.some((pattern) => normalizedMessage.includes(pattern))) {
    return 'You do not have permission to share this product.';
  }

  return error.message || 'Could not create the share link. Please try again.';
}
